export const STATUS_META = {
  new: { l: "Nový", plural: "Noví", pill: "bg-slate-100 text-slate-700 border-slate-200", solid: "bg-slate-500", card: "bg-slate-50 border-slate-200 text-slate-700", dot: "bg-slate-400" },
  in_process: { l: "Na schválenie", plural: "Na schválenie", pill: "bg-orange-50 text-orange-700 border-orange-200", solid: "bg-orange-500", card: "bg-orange-50 border-orange-200 text-orange-800", dot: "bg-orange-400" },
  interview: { l: "Na pohovor", plural: "Na pohovor", pill: "bg-purple-50 text-purple-700 border-purple-200", solid: "bg-purple-600", card: "bg-purple-50 border-purple-200 text-purple-800", dot: "bg-purple-500" },
  hired: { l: "Prijatý", plural: "Prijatí", pill: "bg-emerald-50 text-emerald-700 border-emerald-200", solid: "bg-emerald-600", card: "bg-emerald-50 border-emerald-200 text-emerald-800", dot: "bg-emerald-500" },
  rejected_shredded: { l: "Zamietnutý", plural: "Zamietnutí", pill: "bg-red-50 text-red-700 border-red-200", solid: "bg-red-600", card: "bg-red-50 border-red-200 text-red-800", dot: "bg-red-500" },
  rejected_retain: { l: "Talent Pool", plural: "Talent Pool", pill: "bg-teal-50 text-teal-700 border-teal-200", solid: "bg-teal-600", card: "bg-teal-50 border-teal-200 text-teal-800", dot: "bg-teal-500" },
};

export const STATUS_ORDER = ["new", "in_process", "interview", "hired", "rejected_shredded", "rejected_retain"];
export const KANBAN_ORDER = ["new", "in_process", "interview", "hired", "rejected_retain", "rejected_shredded"];

export const statusLabel = (s) => (STATUS_META[s] || STATUS_META.new).l;

export const REJECT_CONFIRM =
  "POZOR: Tento krok je NENÁVRATNÝ.\n\nOsobné údaje kandidáta (CV, fotka, kontakty, adresa, zručnosti, skúsenosti, vzdelanie, jazyky, detail Career Score…) budú natrvalo skartované a nebude možné ich obnoviť.\n\nPonechá sa iba meno a priezvisko, pozícia, dátum, Career Score, poznámky recruitera a stav Zamietnutý. Kandidát sa presunie do GDPR sekcie.\n\nNaozaj zamietnuť a skartovať údaje?";

export const effectiveStatuses = (c) => {
  const pos = c.positions || [];
  if (c.shredded) return ["rejected_shredded"];
  return pos.length ? [...new Set(pos.map((x) => x.status || "new"))] : [c.pipeline_status || "in_process"];
};

export function StatusPill({ status, testId }) {
  const m = STATUS_META[status] || STATUS_META.new;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap ${m.pill}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} /> {m.l}
    </span>
  );
}
